import React from "react";
import { useCreateSimplyAcincoContext } from "../provider/createSimplyAcinco.provider";
import PrimaryButton from "../../../../../components/buttons/PrimaryButton";

const PaymentComponent = () => {
  const { formData, infoPayment, setStep, setInfoPayment } =
    useCreateSimplyAcincoContext();

  /* IMPORTS Y FUNCIONES PARA PRODUCCIÓN - Comentado para demo
  import { useCreatePurchaseAgents } from "../../../../../services/microservice/agents/purchase/use-purchase-agents";
  const { mutateAsync: createPurchaseAgent, isLoading } = useCreatePurchaseAgents();

  const mapIntervalToUnit = (interval: string): "month" | "day" | "year" => {
    const intervalMap: Record<string, "month" | "day" | "year"> = {
      MENSUAL: "month",
      ANUAL: "year",
      SEMANAL: "day",
      SEMESTRAL: "month",
      QUINCENAL: "day",
      BIENAL: "year",
    };
    return intervalMap[interval.toUpperCase()] || "month";
  };

  const mapIntervalToCount = (interval: string): number => {
    const intervalCountMap: Record<string, number> = {
      MENSUAL: 1,
      ANUAL: 1,
      SEMANAL: 1,
      SEMESTRAL: 6,
      QUINCENAL: 2,
      BIENAL: 2,
    };
    return intervalCountMap[interval.toUpperCase()] || 1;
  };

  const splitFullName = (fullName: string): { firstName: string; lastName: string } => {
    const words = fullName.trim().split(/\s+/).filter(Boolean);
    if (words.length === 0) return { firstName: "", lastName: "" };
    if (words.length === 1) return { firstName: words[0], lastName: "" };
    if (words.length === 2) return { firstName: words[0], lastName: words[1] };
    if (words.length === 3) return { firstName: words[0], lastName: `${words[1]} ${words[2]}` };
    return { firstName: `${words[0]} ${words[1]}`, lastName: words.slice(2).join(" ") || "" };
  };
  */

  const handleNextStep = async () => {
    // MODO DEMO: Simulación de pasarela de pagos
    const demoCheckout = {
      sessionTransaction: `DEMO-${Date.now()}`,
      plan: {
        checkoutUrl:
          "https://subscription-landing.epayco.co/plan/a19cf4f2133a24bb90d6ad3",
      },
      status: "pending",
    };

    // Guardar checkout demo y avanzar al siguiente paso
    setInfoPayment({ ...infoPayment, checkout: demoCheckout });
    setStep((prev) => prev + 1);

    /* CÓDIGO REAL - Comentado para demo
    const amountString =
      formData?.plan?.pricingOptions
        .find((opt) => opt.id === formData.priceOptionId)
        ?.paymentAmountWithTaxes.toString() || "0";

    const { firstName, lastName } = splitFullName(formData.name);

    try {
      const data = {
        amount: Number(amountString) || 0,
        taxes: 0,
        interval: mapIntervalToUnit(
          formData?.plan?.pricingOptions.find(
            (opt) => opt.id === formData.priceOptionId,
          )?.paymentFrequency || "monthly",
        ),
        intervalCount: mapIntervalToCount(
          formData?.plan?.pricingOptions.find(
            (opt) => opt.id === formData.priceOptionId,
          )?.paymentFrequency || "MENSUAL",
        ),
        planName: `PR${amountString}`,
        planDescription: `PR${amountString}`,
        device: {
          imei: formData?.imei || "",
          line: "0000000000",
        },
        client: {
          name: `${firstName} ${lastName}`,
          email: formData?.email || "",
          identification: {
            number: formData?.numberDocument || "",
            type: formData?.typeDocument || "",
          },
        },
        sponsorID: "GREENELECTRONICS",
        pregeneratePolicyId: infoPayment?.pregeneratePolicyId || "",
      };

      const res = await createPurchaseAgent(data);
      if (res) {
        setInfoPayment({ ...infoPayment, checkout: { ...res.data } });
        setStep((prev) => prev + 1);
      }
    } catch (error) {
      console.log(error);
    }
    */
  };

  const handlePreviousStep = () => {
    setStep((prev) => prev - 1);
  };

  return (
    <section className="w-full space-y-6 p-6">
      <h2 className="mb-5 text-center text-3xl font-bold">
        <span>Pago</span>
      </h2>
      <div className="rounded-2xl border-2 border-gray bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-semibold">Datos cliente</h2>
        <dl className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
          <div>
            <dt className="text-gray-500 text-sm">Nombre completo</dt>
            <dd className="font-medium">{formData?.name}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Tipo de documento</dt>
            <dd className="font-medium">{formData?.typeDocument}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Número de documento</dt>
            <dd className="font-medium">{formData?.numberDocument}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Email</dt>
            <dd className="font-medium">{formData?.email}</dd>
          </div>
        </dl>
      </div>
      <div className="rounded-2xl border-2 border-gray bg-white p-4 shadow-sm">
        <h2 className="mb-3 text-lg font-semibold">Datos del plan</h2>
        <dl className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2">
          <div>
            <dt className="text-gray-500 text-sm">Nombre del plan</dt>
            <dd className="font-medium">{formData?.plan?.name}</dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">
              Valor de cobertura IVA incluido
            </dt>
            <dd className="font-medium">
              $
              {formData?.plan?.pricingOptions
                .find((opt) => opt.id === formData.priceOptionId)
                ?.paymentAmountWithTaxes.toString()
                .replaceAll(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}
            </dd>
          </div>
          <div>
            <dt className="text-gray-500 text-sm">Frecuencia de pago</dt>
            <dd className="font-medium">
              {
                formData?.plan?.pricingOptions.find(
                  (opt) => opt.id === formData.priceOptionId,
                )?.paymentFrequency
              }
            </dd>
          </div>
        </dl>
      </div>
      <div className="mt-5 flex w-full justify-between">
        <PrimaryButton
          title="Atrás"
          type="button"
          className={"mt-5 rounded-3xl border px-5 py-1 text-textBlack"}
          style={{ borderColor: "#0a0a0a" }}
          onClick={() => handlePreviousStep()}
        />
        <PrimaryButton
          title="Ir al pago"
          className={
            "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
          }
          onClick={handleNextStep}
          type="button"
        />
      </div>
    </section>
  );
};

export default PaymentComponent;
